<p-card class="dashBoard">
  <table class="header">
    <td><div class="title" [routerLink]="['/rebalancing/rebalance-results']">Rebalances</div></td>
    <td><button class="btn-medium-primary right action" (click)="showCreateRebalance()">Create a rebalance</button></td>
  </table>
  <br class="clear"/>
  @if (!data) {
    <div class='loading-spinner'></div>
  }
  @if (data) {
    <div>
      <div class="pane">
        <table class="dashboard-table">
          <tr class="header key">
            <td class="">Name</td>
            <td class="" style="width: 142px">Type</td>
            <td class="" style="width: 75px">Total</td>
            <td class="" style="width: 80px">With Orders</td>
            <td class="" style="width: 78px">Approved</td>
            <td class="" style="width: 15px"></td>
          </tr>
          @for (item of data; track item; let i = $index) {
            <tr class="row key clickable" (click)="showRebalanceResultSummary(item.rebalPkgId)">
              <td class="truncate" tooltip [tooltipTitle]="item.rebalName" [tooltipRequiresTruncation]="true" tooltipPosition="right" [tooltipHorizontalOffset]="0">{{item.rebalName}}</td>
              <td class="">{{item.rebalTypeDesc}}</td>
              <td class="">{{item.totalPorts | number}}</td>
              <td class="">{{item.totalTradePorts | number}}</td>
              <td class=""><fa-icon [icon]="faCircle" class="cell-icon" [ngClass]="{'irb-green': (item.totalTradePorts == item.totalApprovedPorts || item.totalTradePorts === 0), 'irb-amber': item.totalTradePorts > item.totalApprovedPorts}"></fa-icon>&nbsp;{{item.totalApprovedPorts | number}}</td>
              <td><fa-icon [icon]="faChevronRight"></fa-icon></td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
</p-card>

